import { Box, Stack, Typography } from "@mui/material";

import {
  ExtraCoverageCard,
  ExtraCoverageCardProps,
} from "@covertree/new-business-forms";
import { SubmitButton } from "@covertree/ui";

interface ExtraCoveragesViewProps {
  extraCoveragesToBeRendered: ExtraCoverageCardProps[];
  isFormSubmitting: boolean;
  isD2C: boolean;
}

export function ExtraCoveragesView({
  extraCoveragesToBeRendered,
  isFormSubmitting,
  isD2C,
}: ExtraCoveragesViewProps) {
  return (
    <Stack spacing={2} sx={isD2C ? { pt: 6 } : {}}>
      {!isD2C ? (
        <Typography
          data-testid="would-you-like-extra-coverages-header"
          variant="h4"
          gutterBottom>
          Would you like to add extra coverages?
        </Typography>
      ) : null}
      <Stack spacing={2}>
        {extraCoveragesToBeRendered.map((extra) => (
          <ExtraCoverageCard key={extra.extraCoverageAccessor} {...extra} />
        ))}
      </Stack>
      <Box mt={3}>
        <SubmitButton loading={isFormSubmitting} width={100}>
          Next
        </SubmitButton>
      </Box>
    </Stack>
  );
}
